import { PageSession } from './PageSession';
import {
    InstrumentationComicSession,
    InstrumentationSessionList
} from './InstrumentationPayload';

export class ComicSession
{
    private readonly comicID:   number;
    private readonly mode:      string;
    private pageSessions:       PageSession[];
    private _currentPage:       PageSession | null;

    get currentPage(): PageSession | null { return this._currentPage; }

    constructor(comicID: number, mode: string) {
        this.comicID        = comicID;
        this.mode           = mode;
        this.pageSessions   = [];
        this._currentPage    = null;
    }

    recordActivity(pageNumber: number): void {
        if(!this._currentPage) {
            this.startNewPage(pageNumber);
        }
        else if(this._currentPage.pageNumber !== pageNumber) {
            this.endCurrentPage();
            this.startNewPage(pageNumber);
        }
        else {
            // TODO: Handle case where we're still on the same page.
        }
    }

    startNewPage(pageNumber: number): void {
        this._currentPage = new PageSession(pageNumber);
    }

    endCurrentPage(): void {
        if(this.currentPage) {
            this.currentPage.endPage();
            this.pageSessions.push(this.currentPage);
        }
    }

    toPayload(): InstrumentationComicSession {
        const payload: InstrumentationComicSession = {
            comicId: this.comicID,
            mode: this.mode,
            pageSessions: []
        };
        for(let i = 0; i < this.pageSessions.length; i++) {
            payload.pageSessions.push(this.pageSessions[i].toPayload());
        }
        return payload;
    }
}

export function sessionsToPayload(sessions: ComicSession[]): InstrumentationSessionList {
    const payload: InstrumentationSessionList = { sessions: [] };
    for(let i = 0; i < sessions.length; i++) {
        payload.sessions.push(sessions[i].toPayload());
    }
    return payload;
}